import React__default from 'react';
import { PopupTooltip } from './PopupTooltip.js';
import '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import '@emotion/react';
import '../../utils/mergeRefs.js';
import 'use-debounce';
import '@indeed/ihl-use-id';
import '../../utils/transition.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Popup/Popup.js';
import '@floating-ui/react-dom';
import '@indeed/ifl-css';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';
import '../Portal/Portal.js';
import 'react-dom';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/IndeedThemeProvider.js';
import '@indeed/ifl-icons';
import '../IndeedThemeProvider/theme.js';
import 'deepmerge-ts';
import 'react-fast-compare';
import '@indeed/ifl-themes';
import '../IndeedThemeProvider/utils.js';
import '../LinkProvider/LinkProvider.js';

/**
 * @see https://experience.indeed.design/components/ids/tooltip
 */
const Tooltip = props => /*#__PURE__*/React__default.createElement(PopupTooltip, props);
Tooltip.displayName = "Tooltip";

export { Tooltip };
